import {
  getDesignations as getDesignationsService,
  createDesignation as createDesignationService,
  updateDesignationStatus as updateDesignationStatusService,
  updateDesignation as updateDesignationService,
} from "services/company/userManagement/designation/designationService";
import {
  getDesignationsStart,
  getDesignationsSuccess,
  getDesignationsFailure,
  createDesignationStart,
  createDesignationSuccess,
  createDesignationFailure,
  updateDesignationStatusStart,
  updateDesignationStatusSuccess,
  updateDesignationStatusFailure,
  updateDesignationStart,
  updateDesignationSuccess,
  updateDesignationFailure,
} from "./designationSlice";
import { showSuccessToast, showErrorToast } from "utils/toastNotification";

// Fetch all designations
export const fetchDesignations = () => async (dispatch) => {
  try {
    dispatch(getDesignationsStart());
    const response = await getDesignationsService();

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(getDesignationsSuccess(response.data));
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to fetch designations";
      dispatch(getDesignationsFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Fetch designations error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to fetch designations";
    dispatch(getDesignationsFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Create a new designation
export const createNewDesignation = (designationData) => async (dispatch) => {
  try {
    dispatch(createDesignationStart());
    const response = await createDesignationService(designationData);

    if (response?.meta?.status === true && response?.meta?.code === 200) {
      dispatch(createDesignationSuccess(response.data));
      showSuccessToast(
        response?.meta?.message || "Designation created successfully!",
      );
      return { success: true, data: response.data };
    } else {
      const errorMsg =
        response?.meta?.message || "Failed to create designation";
      dispatch(createDesignationFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  } catch (error) {
    console.error("Create designation error:", error);
    const errorMsg =
      error?.response?.data?.meta?.message ||
      error.message ||
      "Failed to create designation";
    dispatch(createDesignationFailure(errorMsg));
    showErrorToast(errorMsg);
    return { success: false, error: errorMsg };
  }
};

// Update designation status (toggle active/inactive)
export const toggleDesignationStatus =
  (designationId, currentStatus) => async (dispatch) => {
    try {
      dispatch(updateDesignationStatusStart());
      const newStatus = currentStatus === "active" ? "inactive" : "active";
      const response = await updateDesignationStatusService(
        designationId,
        newStatus,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(
          updateDesignationStatusSuccess({
            id: designationId,
            status: newStatus,
          }),
        );
        showSuccessToast(
          response?.meta?.message ||
            `Designation ${
              newStatus === "active" ? "activated" : "inactivated"
            } successfully!`,
        );
        return { success: true };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update designation status";
        dispatch(updateDesignationStatusFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update designation status error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update designation status";
      dispatch(updateDesignationStatusFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };

// Update a designation
export const updateExistingDesignation =
  (designationId, designationData) => async (dispatch) => {
    try {
      dispatch(updateDesignationStart());
      const response = await updateDesignationService(
        designationId,
        designationData,
      );

      if (response?.meta?.status === true && response?.meta?.code === 200) {
        dispatch(updateDesignationSuccess(response.data));
        showSuccessToast(
          response?.meta?.message || "Designation updated successfully!",
        );
        return { success: true, data: response.data };
      } else {
        const errorMsg =
          response?.meta?.message || "Failed to update designation";
        dispatch(updateDesignationFailure(errorMsg));
        showErrorToast(errorMsg);
        return { success: false, error: errorMsg };
      }
    } catch (error) {
      console.error("Update designation error:", error);
      const errorMsg =
        error?.response?.data?.meta?.message ||
        error.message ||
        "Failed to update designation";
      dispatch(updateDesignationFailure(errorMsg));
      showErrorToast(errorMsg);
      return { success: false, error: errorMsg };
    }
  };
